const DEFAULT_CATEGORIES = [
  { value: "electronics", label: "Electronics" },
  { value: "mobiles", label: "Mobiles & Accessories" },
  { value: "computers", label: "Computer & Parts" },
  { value: "home", label: "Home Appliances" },
  { value: "gaming", label: "Gaming" },
  { value: "office", label: "Office Electronics" },
  { value: "audio", label: "Audio & Music" },
  { value: "others", label: "Others" },
];

const getCategories = () => {
  try {
    const saved = localStorage.getItem("custom_categories");
    return saved ? JSON.parse(saved) : DEFAULT_CATEGORIES;
  } catch {
    return DEFAULT_CATEGORIES;
  }
};

// Export as function so it's always fresh
const categoryOptions = [
  { value: "", label: "All Categories" },
  ...getCategories(),
];

const statusOptions = [
  { value: "", label: "All Stock" },
  { value: "low", label: "Low stock" },
  { value: "out", label: "Out of Stock" },
];

module.exports = { statusOptions, categoryOptions, getCategories, DEFAULT_CATEGORIES };
